export function toggleElementInArray(currentItemsArray, toggledItem) {
  if (currentItemsArray.some(({ id }) => id === toggledItem.id)) {
    return currentItemsArray.filter(({ id }) => id !== toggledItem.id);
  }

  return [...currentItemsArray, toggledItem];
}
